(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 699px)";
  var mediaQuery = window.matchMedia(MOBILE_QUERY);

  function isMobile() {
    return mediaQuery.matches;
  }

  function getVisibleSlides(carousel) {
    if (!carousel) {
      return [];
    }

    if (carousel.visibleItems) {
      return carousel.visibleItems.filter(function (slide) {
        return !slide.hidden;
      });
    }

    return Array.from(carousel.querySelectorAll(".product-gallery__media:not([hidden])"));
  }

  function getSelectedIndex(carousel, slides) {
    if (!carousel || !slides.length) {
      return 0;
    }

    if (carousel.selectedSlide) {
      var selectedIndex = slides.indexOf(carousel.selectedSlide);

      if (selectedIndex >= 0) {
        return selectedIndex;
      }
    }

    var carouselRect = carousel.getBoundingClientRect();
    var carouselCenter = carouselRect.left + carouselRect.width / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    slides.forEach(function (slide, index) {
      var rect = slide.getBoundingClientRect();
      var slideCenter = rect.left + rect.width / 2;
      var distance = Math.abs(slideCenter - carouselCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getProgressOffset(carousel, count, size, selectedIndex) {
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    var maxOffset = Math.max(0, 100 - size);

    if (maxScroll > 1) {
      var scrollLeft = clamp(carousel.scrollLeft, 0, maxScroll);

      return clamp((scrollLeft / maxScroll) * maxOffset, 0, maxOffset);
    }

    return clamp(size * selectedIndex, 0, maxOffset);
  }

  function updateProgress(gallery) {
    if (!isMobile() || !gallery) {
      return;
    }

    var carousel = gallery.querySelector("media-carousel");
    var progress = gallery.querySelector("[data-charlotte-mobile-carousel-progress]");

    if (!carousel || !progress) {
      return;
    }

    var slides = getVisibleSlides(carousel);
    var count = slides.length;
    var index = getSelectedIndex(carousel, slides);
    var size = count > 0 ? 100 / count : 0;
    var offset = count > 0 ? getProgressOffset(carousel, count, size, index) : 0;

    gallery.style.setProperty("--charlotte-carousel-progress-size", size + "%");
    gallery.style.setProperty("--charlotte-carousel-progress-offset", offset + "%");
    progress.toggleAttribute("hidden", count <= 1);
  }

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.charlotteMobileCarouselReady === "true") {
      return;
    }

    var carousel = gallery.querySelector("media-carousel");

    if (!carousel) {
      return;
    }

    gallery.dataset.charlotteMobileCarouselReady = "true";

    var progressUpdateFrame = null;

    var requestProgressUpdate = function () {
      if (progressUpdateFrame !== null) {
        return;
      }

      progressUpdateFrame = window.requestAnimationFrame(function () {
        progressUpdateFrame = null;
        updateProgress(gallery);
      });
    };

    carousel.addEventListener("scroll", requestProgressUpdate, { passive: true });
    carousel.addEventListener("carousel:change", requestProgressUpdate);
    carousel.addEventListener("carousel:settle", requestProgressUpdate);
    carousel.addEventListener("carousel:filter", function () {
      window.setTimeout(requestProgressUpdate, 80);
    });
    window.addEventListener("resize", requestProgressUpdate, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", requestProgressUpdate, { passive: true });
    }

    requestProgressUpdate();
  }

  function init() {
    document.querySelectorAll(".product-gallery--charlotte-mobile-carousel").forEach(setupGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", init);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(init);
  }
})();
